import { chakra } from '@plurall/elo-v3';

import { essaysHeaderYearRecipe } from './essays-header.recipe';

export const EssaysHeaderYearFactory = chakra('div', essaysHeaderYearRecipe);
